import { FlexiSlider } from "appworks/graphics/elements/flexi-slider";
import { SliderElement } from "appworks/graphics/elements/slider-element";
import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsTotalLossLimitSliderControl } from "../ags-total-loss-limit-slider-control";

export class AgsTotalLossLimitSliderControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return (
            layer.getSprite("total_loss_limit_slider_track") != null &&
            layer.getSprite("total_loss_limit_slider_fill") != null &&
            layer.getSprite("total_loss_limit_slider_handle") != null &&
            layer.getFlexiText("total_loss_limit_slider_title") != null &&
            layer.getSprite("bg_box_total_loss_limit_slider") != null &&
            layer.getFlexiText("total_loss_limit_slider_label") != null
        );
    }

    public build(layer: Layers): AgsTotalLossLimitSliderControl[] {
        const sliderElement = new SliderElement(
            layer,
            layer.getSprite("total_loss_limit_slider_track"),
            layer.getSprite("total_loss_limit_slider_fill"),
            layer.getSprite("total_loss_limit_slider_handle")
        );

        const slider = new FlexiSlider();
        slider.addTarget(sliderElement);

        const title = layer.getFlexiText("total_loss_limit_slider_title");
        const backgroundGraphic = layer.getSprite("bg_box_total_loss_limit_slider");

        const label = layer.getFlexiText("total_loss_limit_slider_label");
        return [new AgsTotalLossLimitSliderControl(slider, label, title, backgroundGraphic)];
    }
}
